import { render, staticRenderFns } from "./OperationsDetails.vue?vue&type=template&id=cc2dedfa&"
import script from "./OperationsDetails.vue?vue&type=script&lang=ts&"
export * from "./OperationsDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports